// src/pages/services/SoftwareLicensing.jsx
import React from 'react';
import ServiceTemplate from '../../components/services/ServiceTemplate';
import licensingImg from '../../assets/images/expertise.jpg';

const SoftwareLicensing = () => {
  const features = [
    {
      icon: '📜',
      title: 'Flexible Licensing',
      description: 'Subscription, perpetual, or usage-based models to suit your needs'
    },
    {
      icon: '🔧',
      title: 'Ready-Made Products',
      description: 'Deploy quickly with our proven software solutions'
    },
    {
      icon: '🔄',
      title: 'Customizable Options',
      description: 'Adapt our products to your specific requirements'
    },
    {
      icon: '💼',
      title: 'Enterprise Ready',
      description: 'Scalable solutions for businesses of all sizes'
    },
    {
      icon: '🔒',
      title: 'Security Included',
      description: 'Enterprise-grade security with every license'
    },
    {
      icon: '📞',
      title: 'Ongoing Support',
      description: 'Regular updates and dedicated technical assistance'
    }
  ];

  const benefits = [
    'Ready-made products for quick deployment',
    'Adaptable to different business requirements',
    'Cost-effective licensing models',
    'Regular updates and security patches',
    'Enterprise-grade security included',
    'Dedicated technical support team'
  ];

  const technologies = [
    { icon: '🔐', name: 'License Management' },
    { icon: '☁️', name: 'Cloud Deployment' },
    { icon: '🏢', name: 'On-Premise Options' },
    { icon: '📊', name: 'Usage Analytics' },
    { icon: '🔄', name: 'Auto Updates' },
    { icon: '🔒', name: 'DRM Protection' },
    { icon: '📱', name: 'Mobile Access' },
    { icon: '🔌', name: 'API Access' }
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas',
    'Food Industry', 'Logistics', 'Healthcare', 'Education'
  ];

  const process = [
    { title: 'Selection', description: 'Choose the right product for your needs' },
    { title: 'Configuration', description: 'Customize settings and features' },
    { title: 'Deployment', description: 'Quick setup and integration' },
    { title: 'Support', description: 'Ongoing maintenance and assistance' }
  ];

  return (
    <ServiceTemplate
      title="Software Licensing"
      badge="SOFTWARE LICENSING"
      description="Flexible licensing options for ready-made software products. Deploy quickly, scale easily, and get enterprise-grade solutions without the custom development timeline."
      heroImage={licensingImg}
      features={features}
      benefits={benefits}
      technologies={technologies}
      industries={industries}
      process={process}
      ctaText="View Licensing Options"
      ctaLink="/contact"
    />
  );
};

export default SoftwareLicensing;